import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'
import { Button } from '@pepper/ui'

import AppliedFilterPill from 'components/idea-lab/AppliedFilterPill'

const INTENT_MAP: Record<number, string> = {
  0: 'Commercial',
  1: 'Informational',
  2: 'Navigational',
  3: 'Transactional',
}

type Props = {
  formatTopicsAndKeywordsCount: (value: string) => void
  onClearFilter: (
    value: (
      | 'sug_keyword'
      | 'sug_volume:lte'
      | 'sug_volume:gte'
      | 'sug_difficulty:lte'
      | 'sug_difficulty:gte'
      | 'sug_positionLte'
      | 'sug_positionGte'
      | 'sug_exclude_position'
      | 'sug_intent'
    )[]
  ) => void
}

export const SuggestionsFilter = ({
  formatTopicsAndKeywordsCount,
  onClearFilter,
}: Props) => {
  const [queryParams] = useQueryParams({
    sug_keyword: withDefault(StringParam, undefined),
    'sug_volume:lte': withDefault(NumberParam, undefined),
    'sug_volume:gte': withDefault(NumberParam, undefined),
    'sug_difficulty:lte': withDefault(NumberParam, undefined),
    'sug_difficulty:gte': withDefault(NumberParam, undefined),
    theme_id: withDefault(StringParam, undefined),
    sug_positionLte: withDefault(NumberParam, undefined),
    sug_positionGte: withDefault(NumberParam, undefined),
    sug_exclude_position: withDefault(BooleanParam, false),
    sug_intent: withDefault(NumberParam, undefined),
  })
  return (
    <>
      {queryParams.sug_keyword && (
        <AppliedFilterPill
          label={`Inc. Keywords: ${formatTopicsAndKeywordsCount(
            queryParams.sug_keyword
          )}`}
          onClear={() => onClearFilter(['sug_keyword'])}
        />
      )}

      {(queryParams['sug_volume:gte'] || queryParams['sug_volume:lte']) && (
        <AppliedFilterPill
          label={`Vol: ${queryParams['sug_volume:gte']}+`}
          onClear={() => onClearFilter(['sug_volume:gte', 'sug_volume:lte'])}
        />
      )}

      {queryParams.sug_intent !== undefined && (
        <AppliedFilterPill
          label={`Intent: ${INTENT_MAP[queryParams.sug_intent]}`}
          onClear={() => onClearFilter(['sug_intent'])}
        />
      )}

      {(queryParams['sug_difficulty:gte'] ||
        queryParams['sug_difficulty:lte']) && (
        <AppliedFilterPill
          label={`KD%: ${queryParams['sug_difficulty:gte'] ?? 0} - ${
            queryParams['sug_difficulty:lte']
          }%`}
          onClear={() =>
            onClearFilter(['sug_difficulty:lte', 'sug_difficulty:gte'])
          }
        />
      )}

      {queryParams?.sug_positionLte && queryParams.sug_positionGte && (
        <AppliedFilterPill
          label={`Pos: ${queryParams.sug_positionGte} - ${queryParams.sug_positionLte}`}
          onClear={() =>
            onClearFilter([
              'sug_positionLte',
              'sug_positionGte',
              'sug_exclude_position',
            ])
          }
        />
      )}

      {queryParams.sug_exclude_position &&
        !queryParams?.sug_positionLte &&
        !queryParams.sug_positionGte && (
          <AppliedFilterPill
            label="Exclude positions"
            onClear={() =>
              onClearFilter([
                'sug_positionLte',
                'sug_positionGte',
                'sug_exclude_position',
              ])
            }
          />
        )}
      <Button
        type="link"
        onClick={() =>
          onClearFilter([
            'sug_keyword',
            'sug_volume:lte',
            'sug_volume:gte',
            'sug_difficulty:lte',
            'sug_difficulty:gte',
            'sug_positionLte',
            'sug_positionGte',
            'sug_exclude_position',
            'sug_intent',
          ])
        }
      >
        Clear Filter
      </Button>
    </>
  )
}
